import { Component, Input, ChangeDetectionStrategy } from '@angular/core'
import { MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion'
import { ShowContentComponent } from './show-content/show-content.component'
import { Content } from '@monorepo/golab-generated'
import { NgClass } from '@angular/common'

@Component({
  selector: 'app-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, ShowContentComponent, NgClass],
})
export class ContentComponent {
  @Input() content: Content | undefined
  @Input() phaseId: string = ''
}
